import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-11-09'
        tag='Poshmark'
        title="How To Negotiate On Poshmark - The Seller's Guide to Effective Offers"
      >
        <p>
          How do we define a successful business venture? Fame, growth, and sales? Yes, and many more! It is not a
          secret that many factors need to play a part in reaching your goals, leading to success. And to do that, your
          part as an online seller is to know your target market and continuously seek different strategies to make
          sales and grow your business. Doing so opens a window of unlimited opportunities.
        </p>
        <p>
          We all know that online selling has been skyrocketing at present, and more and more people are selling on
          different platforms, may it be a side hustle or a full-time job. Not only can you sell new items, but you can
          also sell used items, as thrifting has become an online trend. Many sellers are making money out of their
          collections. They sell clothes, accessories, and luxury items like bags and shoes.
        </p>
        <p>
          It is undeniable that many buyers are leaning toward online shopping as it offers a diversity of items that
          often comes at competitive retail price. Furthermore, buying in the comforts of your home is also a plus as it
          does not require people to go out and spend their valuable time in traffic or falling in line.
        </p>
        <p>
          Every online marketplace like Poshmark, Mercari, Amazon, eBay, and more, is built uniquely. But what they all
          have in common is that they all have tools and features for retailers to help them increase their sales and
          deal with their potential buyers. On Poshmark, they offer different tools and features to help you grow your
          sales. One of these is the Make an Offer feature, which is an influential factor that most sellers take
          advantage of.
        </p>

        <h3>What is Make an Offer?</h3>
        <p>
          Make an Offer lets buyers and Poshmark sellers negotiate privately on Poshmark about a listing price. While
          sellers can initiate an offer through Bundles or Offers to Likers where a shipping fee discount is required,
          Poshmark buyers can also start a negotiation. The Make an Offer feature is a great way to attract Poshmark
          users and potential buyers as it offers them the freedom to propose a lower price for your listing that they
          are eyeing.
        </p>
        <p>
          Through this, a fair and streamlined negotiation takes place, giving both parties a fair chance to discuss
          their offers. With Make an Offer, offers are binding, which means they cannot be canceled and cannot be
          counted as an accidental purchase. By using the Make an Offer feature, all sales are guaranteed once the offer
          is accepted. This makes the transaction fast and easy in just a few clicks.
        </p>
        <p>
          However, because this feature gives old and new Poshers a chance to offer you the price they want for the item
          in your Poshmark closet, not all buyers' approaches are pleasant and agreeable. You will encounter people who
          will try to get your items at the lowest price possible or lowball offers, which you may find offensive. But!
          Don't worry, as there are some approaches to appropriately respond to these low ballers.
        </p>

        <h3>How It Works For Sellers Like You</h3>
        <p>
          Offers are binding, meaning buyers are committed once they make an offer, as they need to provide payment
          details and their address. This assures you that Poshmark will immediately process the payments once you
          accept the offer from a buyer.
        </p>
        <p>
          When buyers click the Make an Offer button instead of the Buy now button, you will receive an email, a push
          notification, and a notification in your Poshmark "News" tab.
        </p>
        <p>
          Make an Offer is a private negotiation between you and a specific potential buyer. You don't need to worry
          about the public listing price as it will remain firm until the item is sold.
        </p>
        <p>
          Receiving more than one buyer making an offer for an item at the same time should not be a problem. Poshmark
          will cancel all remaining offers once you accept an offer.
        </p>
        <p>
          All offers that are not responded to expire automatically in 24 hours. So, if you choose not to respond to an
          offer, you don't have to take action.
        </p>
        <p>However, there are two kinds of responses that you can make when you receive an offer:</p>
        <ul>
          <li>
            <strong>Accept</strong> - By accepting the offer, the buyer's payment will be processed right away, and you
            will receive a shipping label from Poshmark.
          </li>
          <li>
            <strong>Decline</strong> or Counteroffer: When you counter an offer, you will have to indicate the asking
            price you are willing to sell your listing. Poshmark will then immediately notify the buyer so they can
            respond.
          </li>
        </ul>

        <h3>What To Do During Negotiation</h3>
        <p>
          Typically, you feel a strong psychological pull whenever a potential buyer makes an offer on your listing.
          This can be an exciting time as this ultimately means that someone is interested in buying your item. However,
          not all offers are the same.
        </p>
        <p>
          It is natural for buyers to want to get the best deals. So when given a chance, some may offer a very low ball
          price, even lower than a bargain price, but this doesn't mean you have to accept right away. One crucial
          factor that you should avoid is the seller's remorse or the feeling of regret after accepting a low price for
          an item that you know does not deserve to be sold at a very low price. Remember that you don't have to accept
          any offer if you feel like the price offered is not right.
        </p>
        <p>Here are some tips on how you can negotiate on Poshmark:</p>
        <ul>
          <li>
            <strong>Be fast in countering or accepting offers as they only last 24 hours.</strong> This gives you the
            chance to connect to the buyer expressing interest in your item, and it also serves as an easier way to make
            a sale. Remember that each offer only lasts 24 hours, and if you do not do anything about it, it will
            automatically be canceled.
          </li>
          <li>
            <strong>Expect your buyers to haggle.</strong> It's common for buyers to negotiate as most are always
            looking to steal a good deal. Know that this is okay, and as a seller, you shouldn't take this personally
            and be offended. If you are open to giving some discount on the price of an item, you can negotiate until
            you both reach an agreement.
          </li>
          <li>
            <strong>Offer a discount but still within a healthy profit margin.</strong> This will give your potential
            buyer the satisfaction of getting the item at a lower price. Most buyers feel triumphant when they get an
            item at their desired or discounted price. This makes your buyers happy and helps you facilitate a sale.
          </li>
          <li>
            <strong>Set your upper bound.</strong> Have a price that is a little lower than your sale price. This can
            act as your second-best option if a potential buyer tries to offer you a lower price than what you have
            listed. Think of this as the start of your wiggle room. This will allow you to negotiate some more if the
            buyer counteroffers with another price.
          </li>
          <li>
            <strong>Set your lower bound and be firm about it.</strong> This will serve as your floor price and guide,
            but this should not be your bottom line. You have to be firm about this if you still want to earn a little
            profit. However, be sure to factor in all the commissions and fees Poshmark takes after your sales. Your
            decision to accept an offer near your lower bound can depend on your personal and financial needs.
          </li>
          <li>
            <strong>Counteroffer with a price closer to the buyer's offer.</strong> Send counteroffers that are a bit
            higher than their offer without jeopardizing your lower bound. Make sure that any counteroffer that you
            indicate is still profitable to you. Sending a counteroffer will also let you gauge your buyer's interest in
            your item.
          </li>
          <li>
            <strong>Getting low ball offers is always a possibility.</strong> But it is essential to remain calm and not
            let your emotions cloud your judgment. It is also important to avoid sending offensive words to your
            potential buyer. Always practice professionalism when dealing with unfair offers. Remember, if you do not
            like an offer, you can do nothing as it will eventually expire after 24 hours, or you can always
            counteroffer and let them know that you are firm with your listed price or offer.
          </li>
          <li>
            <strong>Communicate well with your buyer.</strong> You must educate your potential buyer as most of them are
            unaware of how platforms like Poshmark work. You can sympathize with the buyer as they are also paying tax
            and shipping fees, but you can also politely remind them about the little commission you will get after all
            Poshmark fees.
          </li>
        </ul>

        <h3>What To Do When Negotiations Aren't Successful</h3>
        <p>
          As with any business, not all transactions are successful, and there will come a time when you and the buyer
          will not arrive at an agreed price. Things like this are inevitable due to your customers' different demands
          and personalities. We understand that this can be a frustrating moment that can make you regret and you might
          find yourself wishing that you just accepted the buyer's offer instead of waiting for another buyer to come
          along.
        </p>
        <p>
          But remember that you don't have to accept any offer if it doesn't feel right, and you don't need to sacrifice
          your profits to make a sale. Remember that there is someone out there who is the right buyer for your item,
          and you do not need to set a lower price beyond what is profitable and accept unreasonable lowball offers.
        </p>
        <p>
          Do not lose hope, as there are strategies that you can do to boost your sales and attract more Poshers to your
          closet. One of these strategies is relisting your item if your offers are going nowhere. This way, your
          listing can get a fresh start, and new likers may offer you higher prices than previous low offers.
        </p>
        <p>
          If you have a large closet, using a Poshmark bot can benefit you, saving you time and effort in managing your
          closet. OneShop can help you relist, send offers, share, follow, and cross-list across many platforms like
          Mercari, Depop, Tradesy, eBay, and more marketplaces (soon). All these without you having to spend long
          periods in front of your device.
        </p>
        <p>
          OneShop offers a no-risk, 7-day free trial with a responsive support team ready to answer all your questions
          and help you with your closet's needs. If you are ready to experience an intelligent software built to help
          you grow your business, all you have to do is <a href='https://tools.oneshop.com/signup'>sign-up here</a>.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
